var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-group',_vm._b({attrs:{"label":_vm.label,"label-for":_vm.labelFor,"role":"alert"}},'b-form-group',_vm.$attrs,false),[(_vm.tip)?_c('small',{staticClass:"form-group-tip",attrs:{"id":_vm.tipFor}},[_vm._v(" "+_vm._s(_vm.tip)+" ")]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }